import { Badge, IconButton, Tooltip } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useCart } from '../../contexts/CartContext';
import { Link } from 'react-router-dom';
import { storeReturnToForCart } from '../../utils/navigationReturnTo';

interface CartIconButtonProps {
    variant?: 'light' | 'dark';
}

const CartIconButton = ({ variant = 'dark' }: CartIconButtonProps) => {
    const { cartItemsTotal } = useCart();
    const isLight = variant === 'light';
    const iconColor = isLight ? '#ffffff' : '#1a1a1a';
    const hoverBg = isLight ? 'rgba(255, 255, 255, 0.1)' : 'rgba(26, 26, 26, 0.04)';

    const handleCartClick = () => {
        storeReturnToForCart();
    };

    return (
        <Link color="inherit" to="/cart" onClick={handleCartClick}>
            <Tooltip title="Cart" arrow>
                <IconButton
                    sx={{
                        color: iconColor,
                        '&:hover': {
                            backgroundColor: hoverBg,
                        },
                    }}
                >
                    <Badge
                        badgeContent={cartItemsTotal}
                        color="error"
                        sx={{
                            '& .MuiBadge-badge': {
                                right: 3,
                                top: 3,
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                minWidth: '20px',
                                height: '20px',
                            },
                        }}
                    >
                        <ShoppingCartIcon sx={{ fontSize: 30, color: iconColor }} />
                    </Badge>
                </IconButton>
            </Tooltip>
        </Link>
    );
};

export default CartIconButton;
